import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import SectionWrapper from '../shared/SectionWrapper';
import { clients } from '../../data/clients';

const ClientsSection: React.FC = () => (
  <SectionWrapper id="clients" sx={{ py: { xs: 6, md: 10 }, bgcolor: '#0c0c0c' }}>
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textAlign: 'center', mb: 5, letterSpacing: 3, textTransform: 'uppercase', fontWeight: 600, fontSize: '0.7rem' }}
      >
        Trusted by Industry Leaders
      </Typography>
    </motion.div>

    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: { xs: 3, md: 5 },
      }}
    >
      {clients.map((client, i) => (
        <motion.div
          key={client}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: i * 0.04 }}
        >
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
              fontSize: '0.85rem',
              transition: 'color 0.2s ease',
              '&:hover': { color: '#ffffff' },
              cursor: 'default',
            }}
          >
            {client}
          </Typography>
        </motion.div>
      ))}
    </Box>
  </SectionWrapper>
);

export default ClientsSection;
